/**
 * 認証状態のクエリ（03 3.3）：`['auth','me']` に Me（BE 5.3.1）を入れる。staleTime 0（FE-D-033）。
 * トークンは HttpOnly Cookie で画面からは読めず、持たない。localStorage に利用者の情報を残さない（FE-D-024）。
 */
import { useQuery } from '@tanstack/react-query';
import type { AuthVerifyResponse, Me } from '@pcrm/shared';
import { getMe } from '../../api/endpoints/auth';

export const ME_QUERY_KEY = ['auth', 'me'] as const;

/** is_fetch_enabled=false は読み込み済みの値を見るだけ（RequireAuth が読み込む。ボタンの出し分けのたびに API を呼ばない） */
export function useMe(options: { is_fetch_enabled?: boolean } = {}) {
  return useQuery<Me>({
    queryKey: ME_QUERY_KEY,
    queryFn: ({ signal }) => getMe(signal),
    staleTime: 0,
    retry: false,
    enabled: options.is_fetch_enabled ?? true,
  });
}

/** API-AUTH-02 の応答から Me を取り出す（期限の 2 項目を除く） */
export function meOf(result: AuthVerifyResponse): Me {
  return {
    user_code: result.user_code,
    email: result.email,
    user_name: result.user_name,
    affiliated_company_name: result.affiliated_company_name,
    role_code: result.role_code,
    role_name: result.role_name,
    permissions: result.permissions,
    last_login_at: result.last_login_at,
  };
}
